import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import montaDocumentoDia from './montaDocumentoDia';
import { dataHora } from '../../Abordagens/Imprimir/relatorio/formatadores';
import brasao from '../../../../assets/logotipo_doc_novo.png';

// mesma mecânica do relatório de abordagem: pdfmake por import dinâmico (não
// engorda o bundle inicial) e numeração carimbada no documento pronto.
const paraDataURL = src =>
  new Promise(resolve => {
    try {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.getContext('2d').drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        } catch (erro) { resolve(null); }
      };
      img.onerror = () => resolve(null);
      img.src = src;
    } catch (erro) { resolve(null); }
  });

const carregaPdfMake = async () => {
  const [modulo, fontes] = await Promise.all([
    import('pdfmake/build/pdfmake'),
    import('pdfmake/build/vfs_fonts'),
  ]);
  const pdfMake = modulo.default || modulo;
  pdfMake.vfs = (fontes.pdfMake && fontes.pdfMake.vfs) || (fontes.default && fontes.default.pdfMake.vfs);
  return pdfMake;
};

const paraBytes = (pdfMake, doc) =>
  new Promise((resolve, reject) => {
    try { pdfMake.createPdf(doc).getBuffer(resolve); } catch (erro) { reject(erro); }
  });

export default async function gerarPdfDia(dados, opcoes = {}) {
  const [pdfMake, brasaoDataURL] = await Promise.all([carregaPdfMake(), paraDataURL(brasao)]);

  const doc = montaDocumentoDia(dados, {
    brasao: brasaoDataURL,
    emitidoEm: dataHora(new Date().toISOString()),
    emitidoPor: opcoes.emitidoPor || '',
  });

  const bytes = await paraBytes(pdfMake, doc);

  // numeração só aqui, no documento fechado
  const final = await PDFDocument.load(bytes);
  const fonte = await final.embedFont(StandardFonts.Helvetica);
  const paginas = final.getPages();
  paginas.forEach((pagina, i) => {
    const texto = `Página ${i + 1} de ${paginas.length}`;
    const largura = fonte.widthOfTextAtSize(texto, 7);
    pagina.drawText(texto, {
      x: pagina.getSize().width - 40 - largura,
      y: 30,
      size: 7,
      font: fonte,
      color: rgb(0.42, 0.49, 0.53),
    });
  });

  return new Blob([await final.save()], { type: 'application/pdf' });
}

export const nomeDoArquivoDia = (sigla, data) =>
  `relatorio-do-dia-${String(sigla || 'posto').toLowerCase().replace(/\s+/g, '-')}-${data}.pdf`;
